import digiteka from './injectDigiteka';

export default [
  ...digiteka,
]; // needs to run after ads
